import type { FC } from 'react'
import React from 'react'
import { useDownloadDocument } from '@/api/kubik/monolith'
import DocumentContent from '@/components/composed/DocumentContent'
import { Skeleton } from '@/components/ui'
import { Redirect404 } from '@/router/components'
import { legalDocumentsSkeletons, WORKING_CONDITIONS_DOCUMENT_PARAMETERS } from './constants'
import './styles.scss'

const WorkingConditions: FC = () => {
  const {
    data: currentDocument,
    isError,
    isLoading,
  } = useDownloadDocument(WORKING_CONDITIONS_DOCUMENT_PARAMETERS.versionId, {
    client: {
      responseType: 'text',
    },
  })
  const currentDocumentContent = (currentDocument ?? '') as string

  if (isError) {
    return <Redirect404 />
  }

  return (
    <div className="workingConditions page-wrapper page-wrapper_no-mobile">
      <Skeleton isLoading={isLoading} skeletons={legalDocumentsSkeletons}>
        {currentDocumentContent && (
          <DocumentContent
            documentId={WORKING_CONDITIONS_DOCUMENT_PARAMETERS.documentId}
            content={currentDocumentContent}
            previousVersions={[]}
            isActualDocumentVersion
          />
        )}
      </Skeleton>
    </div>
  )
}

export default WorkingConditions
